// @ts-nocheck
import React from "react";
import styled from "styled-components";
import { Button, ButtonProps, useModal, useWalletModal } from "@pancakeswap-libs/uikit";
import { useWeb3React } from "@web3-react/core";
import useAuth from "../../hooks/useAuth";
import ConnectModal from './ConnectModal'

const Btn = styled.button`
user-select: none;
  background: #040E18;
  border-radius: 70px;
  border: 2px solid transparent;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  letter-spacing: .5px;
  line-height: 1;
  margin-bottom: 0;
  padding: 20px 45px;
  text-align: center;
  text-transform: uppercase;
  touch-action: manipulation;
  transition: all 0.4s 0s;
  vertical-align: middle;
  white-space: nowrap;
  box-shadow: 0px 6px 22px rgba(6, 34, 51, 0.22);
  background-clip: padding-box;
  position: relative;
  font-size: 14px;

  &:after  {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: -2px;
    background: linear-gradient(90deg, rgba(0, 196, 244, 1) 0%, rgba(4, 12, 21, 1) 49%, rgba(0, 196, 244, 1) 100%);
    border-radius: 70px;
    transition: all 0.4s ease 0s;
    z-index: -1;
  }

  &:hover {
    border-color: #00C4F4;
    color: #00C4F4;
  }
`;


const ConnectWalletButton: React.FC<ButtonProps & { label?: string }> = (props) => {
  const { account } = useWeb3React();
  const [onPresentConnectModal] = useModal(
    <ConnectModal
    />
  )
  const { label } = props;

  return (
    
    <Btn onClick={onPresentConnectModal} {...props}>
      {account ? "Connected" : label ?? "Connect Wallet to Proceed"}
    </Btn>
  );
};

export default ConnectWalletButton;
